<template>
    <div class="popup" v-if="is_up">
        <div class="picture_div">
            <h5>头像设置</h5>
            <div class="picture_center flex_between">
                <div class="picture_left flex_center">
                    <el-upload class="avatar-uploader flex_center" :action="URL + 'upload'" :show-file-list="false"
                        :on-success="handleAvatarSuccess">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <el-button v-else size="small" type="primary">+点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">点击图片上传，至支持JPG。PNG。GIF.大小不超过5M</div>
                    </el-upload>
                </div>
                <div class="picture_right">
                    <h6 class="flex_center">预览</h6>
                    <i class="picture_img">
                        <img :src="imageUrl" alt="">
                    </i>
                </div>
            </div>
            <div class="tiltiexuan">选择默认头像</div>
            <div >
                 <div class="morenimg clearfix">
               <img :src="item.src" alt="" v-for="(item,index) in imgarr" :key="index" @click="openimg(item.src)">
            </div>
            </div>

            <div class="button_ul flex_center">
                <button class="cancel flex_center" @click="is_up = false">取消</button>
                <button class="confirm flex_center" @click="upImg">确认</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {
                URL: this.$URL,
                imageUrl: '',
                upImage: '',//
                is_up: false,//是否显示上传弹窗
                imgarr:[{src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/95fad0d12ae4ecdf9bad89fb417cd7ac.jpg'},
                {src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/5bdd3d87b1e5888525d6e2e27483f27f.jpg'},
                {src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/e85e417187067af11f3daddeee5497d3.jpg'},
                {src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/c1a1210c74b91c34df547cea7906e3f0.jpg'},
                {src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/6df03bf9d9da98bd06121ebb79a391fe.jpg'},
                {src:'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/d54b88d68d257ce53487f7a36810afd3.jpg'},
                ]
            }
        },
        props: {

        },
        watch: {

        },
        methods: {
            upImg() {//上传头像
                let that = this;
                this.$post('user_modify_image', {
                    member_id: this.USER().id,
                    userimage: this.upImage
                }).then(res => {
                    layer.open({
                        content: '修改成功'
                        , time: 1
                        , skin: 'msg'
                    });
                    that.REFRESH_USER();
                    setTimeout(() => {
                        that.$emit('getUser');
                        that.is_up = false;
                    }, 1000)
                })
            },
            pictureFun() {
                this.imageUrl = this.USER().image;
                this.is_up = true;
            },
            handleAvatarSuccess(res, file) {
                 
                this.upImage = res.data;
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            openimg(src){
                this.imageUrl=src
                this.upImage=src
            }

        },
        mounted() {
            
            // $('.el-upload__input').hide();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .avatar-uploader .el-upload input.el-upload__input {
        display: none;
    }
</style>
<style scoped>
    .popup {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, .4);
        z-index: 999;
    }

    .popup .picture_div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 10px;
        width: 642px;
        max-width: 60vw;
    }

    .picture_div>h5 {
        height: 42px;
        line-height: 42px;
        padding: 0 28px;
        border-bottom: 1px solid #DFDFDF;
        font-size: 16px;
        color: #333;
    }

    /* 上传区域 */
    .picture_center {
        padding: 23px 28px;
        align-items: flex-start;
    }

    .picture_center .picture_left {
        width: 334px;
        height: 334px;
        background: #F2F2F5;
        border: 1px solid #DFDFDF;
        flex-direction: column;
    }

    .upload-demo {
        position: relative;
    }

    input.el-upload__input {
        opacity: 0 !important;
    }

    .picture_center .picture_right {
        flex: 1;
        margin-left: 24px;
    }

    .picture_right>h6 {
        font-size: 16px;
        color: #333;
        line-height: 2em;
    }

    .picture_right .picture_img {
        width: 129px;
        height: 129px;
        border-radius: 50%;
        border: 1px solid #DFDFDF;
        background: #F2F2F5;
        overflow: hidden;
        margin: auto;
    }

    .avatar-uploader {
        flex-direction: column;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
        margin: 0 auto;
        object-fit: contain;
    }

    /* 按钮 */
    .button_ul {
        padding: 36px;

    }

    .button_ul>button {
        width: 146px;
        height: 36px;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
        background: #BFBFBF;
        margin: 0 16px;
        border: 0;
    }

    .button_ul>button.confirm {
        background: #F24D5B;
    }


.morenimg{
        width: 336px;
        margin-left: 28px;
}
    .morenimg img{
        float: left;
        margin-top: 1vw;
        width: 80px;
        height: 80px;
        margin-left: 25px;
        cursor: pointer;
    }
    .tiltiexuan{
        width: 336px;
        text-align: center;
        margin-left: 28px;

    }
    .clearfix:after {
    visibility: hidden;
    clear: both;
    display: block;
    content: ".";
    height: 0
}

.clearfix {
    *zoom: 1
}

</style>


// WEBPACK FOOTER //
// src/components/assembly/ModifyPicture.vue